import { useEffect, useRef } from "react";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { pluralize } from "utils/pluralize";

type PaymentSuccessModalProps = {
  open: boolean;
  entityName: string;
  filingCount: number;
  onDone: () => void;
};

const REDIRECT_DELAY_MS = 3000;

export const PaymentSuccessModal = ({
  open,
  entityName,
  filingCount,
  onDone,
}: PaymentSuccessModalProps) => {
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    if (!open) return undefined;

    const timer = setTimeout(() => onDoneRef.current(), REDIRECT_DELAY_MS);
    return () => clearTimeout(timer);
  }, [open]);

  return (
    <Modal.Root open={open} onOpenChange={(next) => !next && onDone()}>
      <Modal.Content useCustomOverlay size="small">
        <StatusModal
          type="success"
          title="You're all set!"
          showCloseButton={false}
        >
          <div className="t-mt-3 t-flex t-flex-col t-gap-3">
            <p className="t-m-0 t-text-body-sm t-text-text-30">
              You&apos;ve successfully launched{" "}
              {pluralize(filingCount, "filing", "filings")} for {entityName}.
              We&apos;ll take it from here by preparing and submitting your
              filings, and we&apos;ll keep you updated every step of the way.
            </p>

            <span className="t-text-body-sm t-italic t-text-neutral-40">
              Redirecting you to dashboard…
            </span>
          </div>
        </StatusModal>
      </Modal.Content>
    </Modal.Root>
  );
};
